import { render, staticRenderFns } from "./CreateProjectRelation.vue?vue&type=template&id=0d184f15&"
import script from "./CreateProjectRelation.vue?vue&type=script&lang=js&"
export * from "./CreateProjectRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports